import React, { useEffect, useMemo, useState } from 'react';
import styles from './AddGoal.module.scss';
import Close from '../../assets/icons/Close_MD.svg';

const PERIODS = [
  { id: 'day', label: 'День' },
  { id: 'week', label: 'Неделя' },
  { id: 'month', label: 'Месяц' },
];

const LimitGoalForm = ({ value, onChange }) => {
  const [isCommentOpen, setIsCommentOpen] = useState(false);
  const [cats, setCats] = useState([]);
  const set = (patch) => onChange((prev) => ({ ...prev, ...patch }));

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch('/api/categories?kind=expense');
        const data = await res.json();
        setCats(Array.isArray(data) ? data : []);
      } catch {
        setCats([]);
      }
    })();
  }, []);

  const periodIndex = useMemo(() => {
    const i = PERIODS.findIndex((p) => p.id === value.period);
    return i >= 0 ? i : 0;
  }, [value.period]);

  useEffect(() => {
    if (!value.period) set({ period: 'day' });
  }, []);
  

  return (
    <div className={styles.spend__inner}>
      <div className={styles.form__labels}>
        <label className={styles.form__label}>
          <span className={styles.form__labelText}>Название</span>
          <input
            type="text"
            placeholder='"Меньше тратить на кофе"'
            className={styles.form__input}
            value={value.title}
            onChange={(e) => set({ title: e.target.value })}
          />
        </label>

        <div className={styles.form__values}>
          <label className={styles.form__label}>
            <span className={styles.form__labelText}>Лимит</span>
            <input
              type="number"
              placeholder="5 000 ₽"
              className={styles.form__input}
              value={value.limit_amount}
              onChange={(e) => set({ limit_amount: e.target.value })}
            />
          </label>

          <label className={styles.form__label}>
            <span className={styles.form__labelText}>Категория</span>
            <select
              className={styles.form__select}
              value={value.category_id || ''}
              onChange={(e) => set({ category_id: e.target.value })}
            >
              <option value="" disabled>
                Выберите категорию
              </option>
              {cats.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.name}
                </option>
              ))}
            </select>
          </label>
        </div>

        <div className={styles.period}>
          <span className={styles.form__labelText}>Срок лимита</span>

          <div className={styles.period__tabs} role="tablist" aria-label="Срок лимита">
            <div
              className={styles.period__indicator}
              style={{ transform: `translateX(${periodIndex * 100}%)` }}
              aria-hidden="true"
            />

            {PERIODS.map((p) => (
              <button
                key={p.id}
                type="button"
                role="tab"
                aria-selected={value.period === p.id}
                className={styles.period__tab}
                onClick={() => set({ period: p.id })}
              >
                {p.label}
              </button>
            ))}
          </div>
        </div>

        <div className={styles.accordion}>
          <button
            type="button"
            className={styles.accordion__toggle}
            onClick={() => setIsCommentOpen((v) => !v)}
            aria-expanded={isCommentOpen}
          >
            <span
              className={`${styles.accordion__icon} ${
                isCommentOpen ? styles.accordion__iconActive : ''
              }`}
              aria-hidden="true"
            >
              <img src={Close} alt="" />
            </span>
            <span className={styles.accordion__text}>Комментарий (необязательно)</span>
          </button>

          <div
            className={`${styles.accordion__content} ${
              isCommentOpen ? styles.accordion__contentOpen : ''
            }`}
          >
            <div className={styles.accordion__inner}>
              <label className={styles.form__label}>
                <textarea
                  className={styles.form__textarea}
                  placeholder="Зачем / Для чего"
                  value={value.comment}
                  onChange={(e) => set({ comment: e.target.value })}
                  rows={3}
                />
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LimitGoalForm;
